import { withStyles, Container } from "@material-ui/core/";
export default withStyles({
  root: {
    padding: 0,
  },
})(Container);
